export default __webpack_public_path__ + "static/media/donate.0114131c.svg";